import { render, staticRenderFns } from "./contactData.vue?vue&type=template&id=53831376&"
import script from "./contactData.js?vue&type=script&lang=js&"
export * from "./contactData.js?vue&type=script&lang=js&"
import style0 from "./contactData.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53831376')) {
      api.createRecord('53831376', component.options)
    } else {
      api.reload('53831376', component.options)
    }
    module.hot.accept("./contactData.vue?vue&type=template&id=53831376&", function () {
      api.rerender('53831376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contact/contactData/contactData.vue"
export default component.exports